export default __webpack_public_path__ + "static/media/SEC2080.34I-43635_-26070_0.93dfb7b8.jpg";